import { Component, OnInit } from '@angular/core';
import {
  AuthenticatedResult,
  OidcClientNotification,
  OidcSecurityService,
  OpenIdConfiguration,
  UserDataResult,
} from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DivisionHubService } from '../../@core/hubs/division-hub.service';
import { FacilityHubService } from '../../@core/hubs/facility-hub.service';
import { LogService } from '../../@core';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit {
  version: string | null = environment.version;
  configurations!: OpenIdConfiguration[];
  userDataChanged$!: Observable<OidcClientNotification<any>>;
  userData$!: Observable<UserDataResult>;
  isAuthenticated$!: Observable<AuthenticatedResult>;

  constructor(
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    private divisionHub: DivisionHubService,
    private facilityHub: FacilityHubService,
    private logger: LogService
  ) {}

  ngOnInit() {
    this.configurations = this.oidcSecurityService.getConfigurations();
    this.userData$ = this.oidcSecurityService.userData$;
    this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;

    if (this.router.url === '/account/logout') {
      this.oidcSecurityService.logoff();
    }
  }

  login(configId: string | undefined) {
    this.logger.info('Client login.');
    this.oidcSecurityService.authorize(configId);
  }

  forceRefreshSession() {
    this.oidcSecurityService.forceRefreshSession().subscribe((result) => console.warn(result));
  }

  logout(configId: string | undefined) {
    this.divisionHub.stop();
    this.facilityHub.stop();
    this.oidcSecurityService.logoff(configId);
  }
}
